import { TERMS_REQUIRED_CODE } from "@amtana/module";

import { errorCodeOf } from "./errors.ts";

// A door refused because the Terms in force are not accepted (ADR-032, S37.07). It is no failure
// of the screen: it means "show the gate". The framework never throws it to an error boundary and
// never asks again; it tells whoever holds the gate (the platform's shell) to look again.

export function isTermsRefusal(error: unknown): boolean {
  return errorCodeOf(error) === TERMS_REQUIRED_CODE;
}

const listeners = new Set<() => void>();

/** Calls `listener` on every refused read and write; answers the way to stop. */
export function onTermsRefused(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** The query client hands every failure here. */
export function noticeTermsRefusal(error: unknown): void {
  if (isTermsRefusal(error)) for (const listener of listeners) listener();
}
